var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTable',{attrs:{"goodsMarker":"S"},on:{"openEditPage":_vm.openEditPage}})}
var staticRenderFns = []

export { render, staticRenderFns }